export default {
  title: {
    en: 'Address Verification',
  },
  text: {
    en: `
      There is a problem with the address provided. Your address has not been found.
      We highly recommend to update your shipping address.
    `,
  },
  youEntered: {
    en: 'You entered',
  },
  buttons: {
    use: {
      en: 'Use this address',
    },
    edit: {
      en: 'Edit address',
    },
  },
}
